'use client'

import type { Consent } from '@maestro/data-layer'

import { useEffect, useState } from 'react'

import { fetchConsents } from '@maestro/commerce-blocks/components/global-overlays/global-overlays.server-actions'
import { useMaestroSession } from '@maestro/commerce-blocks/providers/maestro-session/maestro-session.context'
import { createLogger } from '@maestro/core/logger'

const log = createLogger('maestro:commerce-blocks:use-global-overlays-client')

export function useGlobalOverlaysClient() {
  const [consents, setConsents] = useState<Consent[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const { session, isLoading: isSessionLoading } = useMaestroSession()
  const isLoggedIn = Boolean(session?.user?.id)

  useEffect(() => {
    // Maestro B2B hide behind login feature
    if (isSessionLoading) {
      return
    }

    // Maestro B2B hide behind login feature
    if (!isLoggedIn) {
      setIsLoading(false)
      return
    }

    const loadData = async () => {
      try {
        const consentsData = await fetchConsents()
        setConsents(consentsData)
      } catch (error) {
        log.error('Failed to fetch consents:', error)
      } finally {
        setIsLoading(false)
      }
    }

    loadData()
  }, [isLoggedIn, isSessionLoading])

  return {
    consents,
    isLoading,
  }
}
